/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentConfig } from './assessmentConfig';
import { ConfigCatalog } from './configCatalog';


export interface AssessmentControllerGetConfigsWithCatalog200Response { 
    applied?: Array<AssessmentConfig>;
    available?: Array<ConfigCatalog>;
    byCategory?: object;
}

